import React from 'react';
import { Brain } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import './BrainLoader.css';

/**
 * "InvestMenter Brain is working for you — loading payment plans…"
 *
 * The one loading line the owner app uses wherever the investor waits on
 * data. Reviewer feedback (2026-09-29): a plain spinner reads as the app being
 * slow; the brain line reads as the app doing work on the investor's behalf.
 *
 * `task` is a translation key naming what is being fetched (imbTaskPlans,
 * imbTaskValuation, …). `compact` is the one-line form for use inside a card.
 */
const BrainLoader: React.FC<{ task?: string; compact?: boolean; dark?: boolean }> = ({ task, compact, dark }) => {
  const { t } = useLanguage();
  return (
    <div
      className={`brl ${compact ? 'brl-compact' : ''} ${dark ? 'brl-dark' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="brl-icon" aria-hidden="true">
        <Brain size={compact ? 18 : 26} />
      </span>
      <span className="brl-text">
        <span className="brl-title">{t('imbWorking')}</span>
        {task && <span className="brl-task">{t(task)}</span>}
      </span>
    </div>
  );
};

export default BrainLoader;
